import { makeStyles } from "tss-react/mui";

const useDataViewStyles = makeStyles()((theme) => ({


  container: {
    padding: "10px",   
    backgroundColor: theme.palette.background.default, 
    margin: "0 auto",
    
  },
  
  dataViewTable: {
    margin: "0 auto",
  

    "& table": {
      width: "100%",
      tableLayout: "fixed",
      background: theme.palette.surface.light,
      borderCollapse: "collapse",

      "& tr": {
        "& td": {
          verticalAlign: "middle",
          padding: "8px 10px",
          paddingLeft: "16px",

          "&.data-view-key": {
            fontWeight: "600",
            color: theme.palette.text.primary,
            overflowWrap: "break-word",
          },

          "&.data-view-value": {
            fontWeight: "400",
            color: theme.palette.text.primary,
            overflowWrap: "break-word",
          },
        },
      },


      "& tbody.data-view-list tr.data-view-list-link td.data-view-key, & tr.data-view-image td.data-view-key": {
        fontWeight: "400", 
        paddingLeft: "25px",
      },

      "& tbody.data-view-list tr.data-view-link td.data-view-key": {
        fontWeight: "400", 
        paddingLeft: "25px",
      },

      "& tbody:nth-of-type(odd)": {
        "& tr.data-view-inline, tr.data-view-link": {
          "& .data-view-key": {
            background: theme.palette.surface.bgNuanced2,
            borderTopLeftRadius: "2px",
            borderBottomLeftRadius: "2px",
          },

          "& .data-view-value": {
            background: theme.palette.surface.bgNuanced2,
            borderTopRightRadius: "2px",
            borderBottomRightRadius: "2px",
          },
        },
      },

      "& tr.data-view-link, tr.data-view-list-link": {
  "& .data-view-value--only-link": {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    display: "block",
  },

  "& a": {
    color: theme.palette.text.accent,
    textDecoration: "underline",
  },
},


      "& tr.data-view-list-inline": {
        "& td.data-view-key": {
          fontWeight: "600",
          color: theme.palette.text.primary,
          paddingLeft: "15px",
          overflowWrap: "break-word",
        },
      },

      
      "& tr.data-view-list-top": {
        "& .data-view-key": {
          paddingTop: "15px",
        },
      },

      "& tr.data-view-block-top": {
        "& .data-view-key": {
          paddingTop: "15px",
          paddingBottom: "0px",
        },
      },

      "& tr.data-view-block-bottom": {
        "& td.data-view-value": {
          lineHeight: "1.4",
          borderRadius: "6px",
          paddingBottom: "10px",
          paddingLeft: "15px",
          paddingRight: "15px",
          fontweight: "400",
          color: theme.palette.text.primary,

          "& p": {
            margin: "2px 0",
          },
        },
      },


      "& tbody.data-view-list": {
        boxShadow: "0 0 0 1px #e6e6e6",
        borderRadius: "6px",

        "& tr.data-view-list-inline": {
          paddingLeft: "20px",
        "& td.data-view-key": {
          fontWeight: "400",
           paddingLeft: "25px",
        },
        "& td.data-view-value": {
          fontWeight: "400",
        },
      },

      

        "& tr:first-of-type td": {
          paddingTop: "15px",
        },

        "& tr:last-child td": {
          paddingBottom: "15px",
        },
      },
    },
  },
}));

export default useDataViewStyles;
